import { AxiosError } from "axios";
import { PagedRules, Rule, RuleUpdateRequest } from "../models/rule";
import { backend } from "../utils/axios";

const ROUTE = "/rules";

export const RuleService = {
  getRules: async (query?: string): Promise<Rule[]> => {
    const params = new URLSearchParams();
    if (query) params.append("query", query);

    const { data } = await backend.get<Rule[]>(ROUTE, { params });

    return data;
  },
  getRulesPaged: async (
    page: number,
    pageSize: number,
    query?: string
  ): Promise<PagedRules> => {
    const params = new URLSearchParams();
    if (query) params.append("query", query);

    const { data } = await backend.get<PagedRules>(
      `${ROUTE}/${page}/${pageSize}`,
      { params }
    );

    return data;
  },
  getRule: async (ruleId: number): Promise<Rule | undefined> => {
    try {
      const { data } = await backend.get<Rule>(`${ROUTE}/${ruleId}`);

      return data;
    } catch (e) {
      if ((e as AxiosError).response?.status === 404) return;
      else throw (e as AxiosError).response?.statusText;
    }
  },
  updateRule: async (
    ruleId: number,
    request: RuleUpdateRequest
  ): Promise<Rule> => {
    const { data } = await backend.put<Rule>(`${ROUTE}/${ruleId}`, request);

    return data;
  },
};
